import { render, staticRenderFns } from "./DragManagement.vue?vue&type=template&id=879efb26&scoped=true"
import script from "./DragManagement.vue?vue&type=script&lang=js"
export * from "./DragManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879efb26",
  null
  
)

export default component.exports